import { render, staticRenderFns } from "./jhi-navbar.vue?vue&type=template&id=55cbdcde"
import script from "./jhi-navbar.component.ts?vue&type=script&lang=ts&external"
export * from "./jhi-navbar.component.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports